import React, { useEffect, useState } from "react";
import MainContainer from "../../layout/MainContainer";
import { Box, Tab, Tabs } from "@mui/material";
import SearchBar from "../../components/SearchBar";
import CustomPagination from "../../components/CustomPagination";
import CancelTable from "./cancelTable";
import { isValidInput } from "../../utils/validations";
import { CancelledBooking, Categories } from "../../types/General";
import { useLazyGetCategoryQuery } from "../../service/category";
import { showError } from "../../constants/toasts";
import {
  useLazyAllEmployeesQuery,
  useLazyGetCancelledBookingsQuery,
} from "../../service/booking";
import { CANCELLATION_STATUS } from "../../utils/enums";
import Loader from "../../constants/Loader";
import { useLocation } from "react-router-dom";
import CancellationFilters from "../../components/CancellationFilters";
import { Dayjs } from "dayjs";
import { useAppDispatch, useAppSelector } from "../../hooks/store";
import { RootState } from "../../app/store";
import {
  resetCancellationFilters,
  setCancellationFilters,
} from "../../reducers/cancellationFiltersSlice";
import { useLazyAllMembersQuery } from "../../service/user";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

interface EmployeeType {
  email: string;
  id: string;
  name: string;
}

const categories = [
  "All",
  "Dining",
  "Event",
  "Experience",
  "Beach Clubs",
  "Benefits",
  "Wellness",
];

export const Cancellation = () => {
  const dispatch = useAppDispatch();
  const cancellationFilters = useAppSelector(
    (state: RootState) => state.cancellationFilters
  );

  const [getCategory] = useLazyGetCategoryQuery();
  const [getCancelledBookings] = useLazyGetCancelledBookingsQuery();
  const [employees] = useLazyAllEmployeesQuery();
  const [getUsers] = useLazyAllMembersQuery();

  const location = useLocation();
  const { state } = location;
  const categoryId = state?.categoryId || "";
  const status = state?.status || 0;
  const categoryTab = state?.categoryTab || 0;

  const [mainTab, setMainTab] = React.useState(0);

  const [subTab, setSubTab] = React.useState(0);
  const [categoryData, setCategoryData] = useState<Categories[]>([]);
  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(10);
  const [page, setPage] = useState(1);
  const [selectedCategoryId, setSelectedCategoryId] = useState<string | null>(
    ""
  );
  const [cancelledBookingData, setCancelledBookingData] = useState<
    CancelledBooking[]
  >([]);

  // const [cancellationFilters, setCancellationFilters] = useState<{
  //   bookingDateFrom: Dayjs | null;
  //   startRange: Dayjs | null;
  //   endRange: Dayjs | null;
  //   memberShipType: string;
  //   categoryId: string;
  //   bookingStatus: string;
  //   subcategoryId: string;
  //   numberofGuest: string;
  //   employeeId: string[];
  //   userId: string[];
  //   isTodayBooking: boolean;
  //   bookingNumberofDays: boolean;
  // }>({
  //   bookingNumberofDays: false,
  //   bookingDateFrom: null,
  //   startRange: null,
  //   endRange: null,
  //   memberShipType: "",
  //   categoryId: "",
  //   bookingStatus: "",
  //   subcategoryId: "",
  //   numberofGuest: "",
  //   employeeId: [],
  //   userId: [],
  //   isTodayBooking: false,
  // });

  const [currentOrder, setCurrentOrder] =
    useState<string>("CancelledDate_desc");

  const [employeeData, setEmployeeData] = useState<EmployeeType[]>([]);
  const [users, setUsers] = useState([]);

  const handleChangeMainTab = (
    event: React.SyntheticEvent,
    newValue: number
  ) => {
    setMainTab(newValue);
    setSubTab(0);
    if (newValue === 0) {
      setSelectedCategoryId("all");
    } else {
      const categoryId = categoryData?.[newValue - 1]?.id || null;
      setSelectedCategoryId(categoryId);
    }
  };

  const handleFilterChange = (key: string, value: any) => {
    dispatch(setCancellationFilters({ [key]: value }));
  };

  const handleClearAll = () => {
    dispatch(resetCancellationFilters());
  };

  const handleChangeSubTab = (
    event: React.SyntheticEvent,
    newValue: number
  ) => {
    setSubTab(newValue);
  };

  function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <>{children}</>}
      </div>
    );
  }

  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");

  const getCancelledBookingsApi = async (clearAll?: any) => {
    try {
      setLoading(true);

      const body: Record<string, any> = {
        ...(cancellationFilters.startRange && !clearAll
          ? { startRange: cancellationFilters.startRange?.toISOString() }
          : {}),
        ...(cancellationFilters.endRange && !clearAll
          ? { endRange: cancellationFilters.endRange?.toISOString() }
          : {}),
        ...(cancellationFilters.bookingDateFrom && !clearAll
          ? {
              cancelDateFrom:
                cancellationFilters.bookingDateFrom?.toISOString(),
            }
          : {}),
        ...(cancellationFilters.userId && !clearAll
          ? { userId: cancellationFilters.userId }
          : {}),
        ...(cancellationFilters.memberShipType && !clearAll
          ? { memberShipType: cancellationFilters.memberShipType }
          : {}),
        ...(cancellationFilters.employeeId && !clearAll
          ? { employeeId: cancellationFilters.employeeId }
          : {}),
        ...(cancellationFilters.numberofGuest && !clearAll
          ? { numberofGuest: cancellationFilters.numberofGuest }
          : {}),
        ...(cancellationFilters.bookingNumberofDays && !clearAll
          ? { bookingNumberofDays: 30 }
          : {}),
        ...(cancellationFilters.isTodayBooking && !clearAll
          ? { isTodayCancellation: cancellationFilters.isTodayBooking }
          : {}),
      };

      const response = await getCancelledBookings({
        page: page,
        search: debouncedSearchTerm,
        categoryId: selectedCategoryId,
        status:
          subTab === CANCELLATION_STATUS.PENDING
            ? "PendingCancellation"
            : subTab === CANCELLATION_STATUS.PENDING_PAYMENT
              ? "PendingCancellationPayment"
              : subTab === CANCELLATION_STATUS.CANCELLED
                ? "Cancelled"
                : "",
        sortOrder: currentOrder,
        body,
      }).unwrap();
      setLoading(false);
      if (response.status === 200) {
        setCancelledBookingData(response?.data?.result?.items || []);
        setCount(response?.data?.result?.totalCount || 0);
      } else {
        setCancelledBookingData([]);
        setLoading(false);
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  const getCategoryApi = async () => {
    try {
      const response = await getCategory({ search: "" }).unwrap();
      if (response.status === 200) {
        setCategoryData(response?.data || []);
        // setCount(response?.data?.totalCount);
        if (categoryId) {
          setSelectedCategoryId(categoryId);
        } else {
          setSelectedCategoryId("all");
        }
      } else {
        setCategoryData([]);
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  const getEmployeesApi = async () => {
    try {
      const response = await employees({}).unwrap();
      if (response.status === 200) {
        setEmployeeData(response?.data || []);
      } else {
        setEmployeeData([]);
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  const getUsersApi = async () => {
    setLoading(true);
    try {
      const response = await getUsers({
        search: "",
      }).unwrap();

      setLoading(false);

      if (response.status === 200) {
        setUsers(response?.data || []);
      } else {
        setUsers([]);
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  useEffect(() => {
    getCategoryApi();
  }, []);

  useEffect(() => {
    if (selectedCategoryId && currentOrder) {
      getCancelledBookingsApi();
    }
  }, [subTab, debouncedSearchTerm, selectedCategoryId, page, currentOrder]);

  useEffect(() => {
    getCategoryApi();

    if (categoryId) {
      setSelectedCategoryId(categoryId);
    }

    if (categoryTab) {
      setMainTab(categoryTab);
    }

    if (status) {
      setSubTab(status);
    }
  }, []);

  useEffect(() => {
    getEmployeesApi();
    getUsersApi();
  }, []);

  return (
    <MainContainer>
      <Loader isLoad={loading} />
      <div className="main_title d_flex">
        <div className="left_s">
          <h1>Cancellation Requests</h1>
        </div>

        <div className="right_s">
          <div className="left_s">
            <Box className="search_box">
              <SearchBar
                searchTerm={searchTerm}
                placeholder="Search...."
                setDebouncedSearchTerm={setDebouncedSearchTerm}
                value={searchTerm}
                onCross={() => setSearchTerm("")}
                onChange={(val: any) => {
                  if (isValidInput(val.target.value)) {
                    setSearchTerm(val.target.value);
                  }
                }}
              />
            </Box>
          </div>
          <div className="right_s">
            <CancellationFilters
              startDate={cancellationFilters.startRange}
              endDate={cancellationFilters.endRange}
              setStartDate={(date) => handleFilterChange("startRange", date)}
              setEndDate={(date) => handleFilterChange("endRange", date)}
              bookingDateFrom={cancellationFilters.bookingDateFrom}
              setBookingDateFrom={(value) =>
                handleFilterChange("bookingDateFrom", value)
              }
              selectedUsers={cancellationFilters.userId}
              setSelectedUsers={(value) => handleFilterChange("userId", value)}
              memberShipType={cancellationFilters.memberShipType}
              setMemberShipType={(value) =>
                handleFilterChange("memberShipType", value)
              }
              selectedCategory={cancellationFilters.categoryId}
              setSelectedCategory={(value) =>
                handleFilterChange("categoryId", value)
              }
              internalData={[]}
              bookingStatus={cancellationFilters.bookingStatus}
              setBookingStatus={(value) =>
                handleFilterChange("bookingStatus", value)
              }
              selectedEmployee={cancellationFilters.employeeId}
              setSelectedEmployee={(value) =>
                handleFilterChange("employeeId", value)
              }
              numberOfGuests={cancellationFilters.numberofGuest}
              setNumberOfGuests={(value) =>
                handleFilterChange("numberofGuest", value)
              }
              bookingNumberofDays={cancellationFilters.bookingNumberofDays}
              setBookingNumberofDays={(value) =>
                handleFilterChange("bookingNumberofDays", value)
              }
              isTodayBooking={cancellationFilters.isTodayBooking}
              setIsTodayBooking={(value) =>
                handleFilterChange("isTodayBooking", value)
              }
              users={users}
              employeeData={employeeData}
              handleSubmit={getCancelledBookingsApi}
              noCategory
              noStatus
              category={[]}
              handleClearFilters={handleClearAll}
            />
          </div>
        </div>
      </div>

      {/* Main Tabs */}
      <Box className="custom_tabs2 mt_40 mb_30" sx={{ width: "100%" }}>
        <Tabs
          value={mainTab}
          onChange={handleChangeMainTab}
          aria-label="Main Tabs"
          className="custom_tabs_links"
        >
          <Tab key="all" label="All" {...a11yProps(0)} />
          {categoryData?.map((item, i) => (
            <Tab key={item.id} label={item?.name} {...a11yProps(i + 1)} />
          ))}
        </Tabs>
      </Box>

      {/* Render Content for Each Main Tab */}
      <CustomTabPanel value={mainTab} index={mainTab}>
        <div className="cards table_cards v2">
          <Box className="custom_tabs" sx={{ width: "100%" }}>
            <Tabs
              value={subTab}
              onChange={handleChangeSubTab}
              aria-label="Sub Tabs"
              className="custom_tabs_links"
            >
              <Tab label="Pending Requests" {...a11yProps(0)} />
              <Tab label="Pending Payments" {...a11yProps(1)} />
              <Tab label="Cancelled Requests" {...a11yProps(2)} />
            </Tabs>
          </Box>

          {/* Sub Tabs Content */}
          <CustomTabPanel value={subTab} index={0}>
            <CancelTable
              actionType="quick"
              category={categories[mainTab]}
              bookingData={cancelledBookingData}
              getCancelledBookingsApi={getCancelledBookingsApi}
              loading={loading}
              setLoading={setLoading}
              mainTab={mainTab}
              categoryId={selectedCategoryId}
              subTab={subTab}
              employeeData={employeeData}
              setEmployeeData={setEmployeeData}
              sortOrder={currentOrder}
              setSortOrder={setCurrentOrder}
            />
          </CustomTabPanel>

          <CustomTabPanel value={subTab} index={1}>
            <CancelTable
              actionType="quick"
              category={categories[mainTab]}
              bookingData={cancelledBookingData}
              getCancelledBookingsApi={getCancelledBookingsApi}
              loading={loading}
              setLoading={setLoading}
              mainTab={mainTab}
              categoryId={selectedCategoryId}
              subTab={subTab}
              employeeData={employeeData}
              setEmployeeData={setEmployeeData}
              sortOrder={currentOrder}
              setSortOrder={setCurrentOrder}
            />
          </CustomTabPanel>
          <CustomTabPanel value={subTab} index={2}>
            <CancelTable
              actionType="quick"
              category={categories[mainTab]}
              bookingData={cancelledBookingData}
              getCancelledBookingsApi={getCancelledBookingsApi}
              loading={loading}
              setLoading={setLoading}
              mainTab={mainTab}
              categoryId={selectedCategoryId}
              subTab={subTab}
              employeeData={employeeData}
              setEmployeeData={setEmployeeData}
              sortOrder={currentOrder}
              setSortOrder={setCurrentOrder}
            />
          </CustomTabPanel>
        </div>
        <CustomPagination
          currentPage={page - 1}
          totalPages={Math.ceil(count / 10)}
          count={count}
          pageSize={10}
          onPageChange={(page) => setPage(page + 1)}
        />
      </CustomTabPanel>
    </MainContainer>
  );
};

export default Cancellation;
